/**
 * Synchronizes scrolling across containers, including dynamically rendered elements.
 * @param {String} containerSelector1 - Selector for the first container.
 * @param {String} containerSelector2 - Selector for the second container.
 */
export const syncScroll = (containerSelector1, containerSelector2) => {
    const getContainers = () => document.querySelectorAll(`${containerSelector1}, ${containerSelector2}`);

    let isSyncing = false;

    const syncScrollPosition = (scrollingContainer) => {
        if (isSyncing) return;
        isSyncing = true;

        const { scrollLeft, scrollTop } = scrollingContainer;
        const containers = getContainers();

        containers.forEach(container => {
            if (container !== scrollingContainer) {
                if (container.scrollLeft !== scrollLeft) container.scrollLeft = scrollLeft;
                if (container.scrollTop !== scrollTop) container.scrollTop = scrollTop;
            }
        });

        isSyncing = false;
    };

    const bindScrollListeners = () => {
        const containers = getContainers();
        containers.forEach(container => {
            container.addEventListener('scroll', () => {
                if (document.body.contains(container)) syncScrollPosition(container);
            });
        });
    };

    // Wait for Alpine.js to finish rendering before attaching listeners
    document.addEventListener('alpine:init', () => {
        setTimeout(bindScrollListeners, 0); // Defer binding to ensure elements are ready
    });

    // Attach listeners initially for any pre-existing elements
    bindScrollListeners();
};
